module.exports = __webpack_public_path__ + "img/nueva.45b556d0.png";